var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADAFC1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M2.727 18h14.546a.727.727 0 00.727-.727V2.727A.727.727 0 0017.273 2H2.727A.727.727 0 002 2.727v14.546c0 .401.326.727.727.727z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADAFC1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14.364V9.273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADAFC1",
    d: "M9.999 5.455a.545.545 0 100 1.09.545.545 0 000-1.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADAFC1",
    fillRule: "evenodd",
    d: "M9.999 5.636a.364.364 0 100 .728.364.364 0 000-.728zM9.27 6a.727.727 0 111.455 0 .727.727 0 01-1.455 0z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8a1316dd.svg";
export { ForwardRef as ReactComponent };